export default "__VITE_ASSET__CPYqtmvN__"